import { getJWT } from "@medimo/core-auth";
import { createMedimoClientQuery, createMeidmoClient } from "./client";

/**
 * medimo internal apiを叩くためのクライアント。
 * `NEXT_PUBLIC_API_URL`をアプリ側で設定する必要がある。
 * @returns medimo internal api client
 */
export const medimo = createMeidmoClient({
  baseUrl: process.env.NEXT_PUBLIC_API_URL,
  getJWT,
});

/**
 * medimo internal apiを叩くためのreact-queryクライアント。
 * `NEXT_PUBLIC_API_URL`をアプリ側で設定する必要がある。
 * @returns medimo internal api client
 */
export const medimoQC = createMedimoClientQuery({
  baseUrl: process.env.NEXT_PUBLIC_API_URL,
  getJWT,
});

/**
 * 認証前（ログイン前）に呼ぶ public エンドポイント用のクライアント。
 * `getJWT` を渡さないため Authorization ヘッダを付与しない。
 * @returns medimo internal api client (unauthenticated)
 */
export const medimoPublicQC = createMedimoClientQuery({
  baseUrl: process.env.NEXT_PUBLIC_API_URL,
});
